module.exports = __webpack_public_path__ + "static/media/chatNew.2dcf6928.svg";